import React, { Component, Fragment } from 'react';
// import {Link} from 'react-router-dom';
import { translate } from 'react-i18next';
// import {Icon} from '../../Common/Icon';
import Loader from '../../Common/Loader';
import {Icon} from '../../Common/Icon';
import cx from '../../../styles';
import EmailLogin from '../EmailLogin';
import CONFIG from '../../../config';
import {gtmSend} from '../../../helpers';
// import ForgotPassword from '../forgotPassword';

class LoginPage extends Component {

    constructor(props) {
        super(props);
        this.state = {isActiveEmailLogin: false, isNavigatorDefine: false, isNewUser: false};
    }

    onEmailClick = (value) => {
        this.setState({isActiveEmailLogin: value, isNewUser: false});
    }
    onCloseEmail = () => {
        this.setState({isActiveEmailLogin: false});
    }

    onGetStartedClick = () => {
        this.setState({isActiveEmailLogin: true, isNewUser: true});
        gtmSend('dynamic', 'Get Started', 'click', 'login page');
    }

    componentDidMount() {
        if(typeof window != 'undefined'){
            if(navigator.userAgent.indexOf('Firefox') === -1 )
            {
                this.setState({
                    isNavigatorDefine: true
                })
            }
        }
    }

    render() {
        const t = this.props.t;

        return (
            <Fragment>
                <div className={cx("login-page")}>
                    <header>
                        {/*<div className={cx("")} style={{paddingTop: '10px', paddingLeft: '10px'}}>
                            <div className={cx("")}>
                                <a className={cx("only-mobile")} onClick={() => this.props.onMobileCrossClick('page')} style={{height: '32px', marginTop: '2px'}}>
                                    <Icon name="cross-regular-dark-smd" />
                                </a>    
                            </div>
                        </div>*/}
                    </header>

                    <div className={cx("left-sec", CONFIG['region']['region'])}>

                    </div>

                    <div className={cx("right-sec")}>
                        {
                            this.state.isActiveEmailLogin && 
                            <EmailLogin
                                onEmailLogin={this.props.onEmailLogin}
                                onCloseEmail={this.onCloseEmail}
                                emailCheck={this.props.emailCheck}
                                onForgotPassword={this.props.onForgotPassword}
                                isNewUser={this.state.isNewUser}
                                isLoginPage={true} />
                        }
                        <div className={cx("login-section")}>

                            {
                                this.props.ifTapPoll
                                ?
                                    ""
                                :
                                    <div className={cx('ls-top')}>
                                        <h1>{t('login_main_title')}</h1>
                                        <p>{t('login_quality_answers')}</p>
                                    </div>

                            }
                            <div className={cx("ls-body")}>
                                <h2>{this.props.ifTapPoll ? t('login_vote_using') : t('login_with')}</h2>

                                <div className={cx('main-section', (this.props.urlParams.indexOf("vars") > -1 && 'hide'))}>
                                    <div className={cx("button-wrap")}>
                                        {
                                            this.props.socialLoginButtons.map((Button, i) => {
                                                return <Button key={i} />;
                                            })
                                        }
                                        <div className={cx('email-icon')} onClick={() => this.onEmailClick(true)}>
                                            <Icon name="email-icon" />
                                        </div>
                                    </div>
                                    <div>{t('or')}</div>
                                    <div className={cx('get-started-btn')} onClick={this.onGetStartedClick}>
                                        <span>{t('get_started')}</span>
                                        <Icon name="right-arrow-btn" />
                                    </div>
                                    {/*<div onClick={() => this.onEmailClick(true)}>
                                    {
                                        this.state.isNavigatorDefine
                                        ?
                                        <input className={cx("open-email-input")} name="input_user_email" type="text" placeholder={t('email')} autoComplete="off" disabled/>
                                        :
                                        <input className={cx("open-email-input")} name="input_user_email" type="text" placeholder={t('email')} autoComplete="off" readOnly/>
                                    }
                                    </div>*/}
                                </div>

                                <div className={cx((this.props.urlParams.indexOf("vars") === -1) && 'hide')}>{t('login_redirecting')}</div>                                

                                <p>{t('login_we_dont_post')}</p>

                                <p><a href='/privacy' target="_blank">T&C</a></p>
                            </div>
                        </div>
                        <div className={cx("login-footer-container", this.props.ifTapPoll && 'hide')}>
                            <div className={cx("footer-left-text")}>
                                <p>{t('login_footer_title')}</p>
                            </div>
                            <div className={cx("footer-country-flag")}>
                                <div className={cx("flag-icons")}>
                                    <div>
                                        <em className={cx("flag-icons-sprite flag-singapore")}></em>
                                        <p>Singapore</p>
                                    </div>
                                </div>
                                <div className={cx("flag-icons")}>
                                    <div>
                                        <em className={cx("flag-icons-sprite flag-philippines")}></em>
                                        <p>Philippines</p>
                                    </div>
                                </div>
                                <div className={cx("flag-icons")}>
                                    <div>
                                        <em className={cx("flag-icons-sprite flag-indonesia")}></em>
                                        <p>Indonesia</p>
                                    </div>
                                </div>
                                <div className={cx("flag-icons")}>
                                    <div>
                                        <em className={cx("flag-icons-sprite flag-thailand")}></em>
                                        <p>Thailand</p>
                                    </div>
                                </div>
                                <div className={cx("flag-icons")}>
                                    <div>
                                        <em className={cx("flag-icons-sprite flag-malaysia")}></em>
                                        <p>Malaysia</p>
                                    </div>
                                </div>
                                <div className={cx("flag-icons")}>
                                    <div>
                                        <em className={cx("flag-icons-sprite flag-vietnam")}></em>
                                        <p>Vietnam</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                                
                {this.props.children}

                {this.props.isLoading && <Loader />}
            </Fragment>
        );
    }
}

export default translate()(LoginPage);
